<template>
    <div class="sc-typing-indicator">
        <span></span>
        <span></span>
        <span></span>
    </div>
</template>
<script>
export default {
    props: {
        messageColors: {
            type: Object,
            required: true,
        },
    },
};
</script>
<style scoped>
/* Sabit 50px yazma cubugunun yuksekligini karsilamiyordu: noktalar cubugun
   ustune binip yariya kesiliyordu. Cubuk calisma aninda olculuyor. */
.sc-typing-indicator {
    position: absolute;
    display: flex;
    align-items: center;
    gap: 4px;
    bottom: var(--sps-input-h, 70px);
    margin: 0 0 8px var(--sps-gutter, 12px);
    padding: 9px 12px;
    border-radius: var(--sps-radius-pill, 999px);
    background: var(--agent-bubble-color, #f1ecff);
    animation: sps-typing-in 0.2s ease-out both;
}

.sc-typing-indicator span {
    display: block;
    background-color: var(--agent-bubble-text-color, #8a8a95);
    width: 7px;
    height: 7px;
    border-radius: 50%;
    opacity: 0.45;
    /* Kisa dongu, kucuk hareket, yumusak egri: eski 2sn'lik sert ziplama gitti. */
    animation: sps-typing-bob 1.4s cubic-bezier(0.45, 0, 0.55, 1) infinite;
}

.sc-typing-indicator span:nth-child(2) {
    animation-delay: 0.16s;
}

.sc-typing-indicator span:nth-child(3) {
    animation-delay: 0.32s;
}

@keyframes sps-typing-bob {
    0%,
    60%,
    100% {
        transform: translateY(0);
        opacity: 0.45;
    }
    30% {
        transform: translateY(-4px);
        opacity: 1;
    }
}

@keyframes sps-typing-in {
    from {
        opacity: 0;
        transform: translateY(4px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (prefers-reduced-motion: reduce) {
    .sc-typing-indicator,
    .sc-typing-indicator span {
        animation-duration: 0.01ms;
        animation-iteration-count: 1;
    }
    .sc-typing-indicator span {
        opacity: 0.7;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/messages/TypingMessage.vue